import { ObjectId } from '@racemap/sdk/schema/base';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { DataNode } from 'antd/es/tree';
import { useHighlightedTrackers } from '../../../lib/customHooks';
import { useStore } from '../../../store/reducers';
import { AddTrackerTagButton } from '../TrackerMessagesTable/AddTrackerTagButton';
import { Filters } from './FilterTreeFunctions';
import { TrackerTagEditField } from './TrackerTagEditField';
import { draggableDataNode } from './nodes';
import type { DataNodeProps } from './prepareFilterSubTreeComponentMapping';

export const TagFilterNode = (props: DataNodeProps): DataNode => {
  const { key, title } = props;
  const trackerTags = useStore((s) => s.trackers.trackerTags);
  const filterCounts = useStore((s) => s.trackers.filterCounts);
  const counts = filterCounts.get(Filters.Tags);
  const highlightedTrackers = useHighlightedTrackers();

  const nodes: Array<DataNode> = Array.from(trackerTags.values()).map(
    (tag): DataNode =>
      draggableDataNode(
        <TrackerTagEditField tag={tag} />,
        `${key}/${tag.id.toHexString()}`,
        counts?.get(tag.id.toHexString()),
      ),
  );
  nodes.push({
    title: <AddTrackerTagButton trackers={[]} buttonLabel="Add tag" />,
    key: `${key}/add_tag`,
    disabled: true,
  });

  if (highlightedTrackers.length !== 0) {
    nodes.push({
      title: (
        <AddTrackerTagButton
          trackers={highlightedTrackers.map((tracker) => new ObjectId(tracker.id))}
          buttonLabel="Tag highlighted trackers"
          color={RacemapColors.PaleBlue}
        />
      ),
      key: `${key}/tag_highlighted_trackers`,
      disabled: true,
    });
  }

  return {
    key,
    title,
    children: nodes,
    disableCheckbox: true,
  };
};
